<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label">รหัส(Supplier) :</label>
                  <span class="form-control-plaintext">{{ suuNo }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label">ชื่อ(Supplier) :</label>
                  <span class="form-control-plaintext">{{ suuName }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label">เลขประจำตัวผู้เสียภาษี :</label>
                  <span class="form-control-plaintext">{{ suuTaxNo }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label>ประเภท Supplier:</label>
                  <treeselect v-model="OwnerTypeCode" :options="OwnerTypeCodeOption"
                    :clear-on-select="true" placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label">ที่อยู่ :</label>
                  <span class="form-control-plaintext">{{ suuAddress }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label">E-mail :</label>
                  <span class="form-control-plaintext">{{ suuEmail }}</span>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <label class="label">เบอร์โทร :</label>
                  <span class="form-control-plaintext">{{ suuTel }}</span>
                </div>
              </div>
            </div>
            <!-- Begin:Map element -->
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>ตำแหน่งที่ตั้ง:</label>
                  <div v-if="suuLat === null">
                    <button
                      type="button"
                      class="btn m-btn--pill btn-info btn-block col-xl-2"
                      @click="getMap"
                    >
                      ระบุข้อมูลตำแหน่งที่ตั้ง
                    </button>
                  </div>
                  <div v-else>
                    <GmapMap
                      :center="{ lat: suuLat, lng: suuLng }"
                      :zoom="15"
                      :clickable="true"
                      @click="updateCoordinates"
                      style="width: 500px; height: 300px"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in suuMarkers"
                        :position="m.position"
                        :draggable="true"
                        @drag="updateCoordinates"
                        :clickable="true"
                        @click="updateCoordinates"
                      ></gmap-marker>
                    </GmapMap>
                    <br />
                    <div>
                      <button
                        type="button"
                        class="btn btn-sm btn-secondary"
                        @click="openMap()"
                      >
                        <i class="far fa-map"></i> Open GoogleMaps
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End:Map element -->
            <!-- Begin:Picture element -->
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label
                    >รูปภาพ:<span
                      class="text-sm text-danger"
                      style="font-size:small"
                    >
                      (เลือกได้เฉพาะสกุลไฟล์ JPG, JPEG,PNG ขนาดไม่เกิน
                      10Mb.)</span
                    ></label
                  >
                  <button
                    type="button"
                    class="btn m-btn--pill btn-info btn-block col-xl-2"
                    @click="uploadFile"
                  >
                    <i class="flaticon-upload-1"></i>รูป
                  </button>
                  <div class="row" id="container-img">
                    <div
                      v-for="(image, index) in FileUpload"
                      :key="index"
                      class="col-md-4 m--margin-top-20 img-wrap"
                    >
                      <img
                        v-if="image.isLoaded !== false"
                        :src="image.urlImg"
                        class="img-plant img-thumbnail card-img-top"
                        @error="handleImageError(image)"
                        @load="handleImageLoad(image)"
                      />
                      <div v-else class="img-placeholder">ไม่สามารถโหลดรูปภาพได้</div>
                      <a
                        href="javascript:;"
                        style="position:absolute;top:10px;right:20px;"
                        class="btn m-btn--pill btn-danger m-btn close"
                        @click="removeImage(image.pictureId)"
                      >
                        <span class="m--font-inverse-danger la la-trash"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End:Picture element -->
            <div class="col-xl-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="suuInActiveStatus"
                      id="suuInActiveStatus"
                      v-model="suuInActiveStatus"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places",

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      suuNo: null,
      suuName: null,
      suuTaxNo: null,
      suuEmail: null,
      suuTel: null,
      suuAddress: null,
      suuInActiveStatus: true,
      suuLat: null,
      suuLng: null,
      suuMarkers: [],
      FileUpload: [],
      OwnerTypeCode: null,
      OwnerTypeCodeOption: [],
    };
  },
  methods: {
    uploadFile() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/jpeg,image/png,image/jpg";
      input.click();
      input.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            const newImage = {
              pictureId: `new_${Date.now()}`,
              urlImg: e.target.result,
              fileName: file.name,
              isNew: true,
              fileDataContext: file,
              isLoaded: true,
            };
            this.FileUpload.push(newImage);
          };
          reader.readAsDataURL(file);
        }
      });
    },
    removeImage(pictureId) {
      Swal.fire({
        title: "ยืนยันคำสั่ง",
        text: "คุณต้องการลบรูปภาพนี้หรือไม่",
        icon: "warning",
        confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
        confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
        showCancelButton: true,
        cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
        cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon",
      }).then((result) => {
        if (result.value) {
          this.FileUpload = this.FileUpload.filter((img) => img.pictureId !== pictureId);
          Swal.fire("เรียบร้อย!", "ลบรูปภาพเรียบร้อย", "success");
        }
      });
    },
    handleImageError(image) {
      image.isLoaded = false;
    },
    handleImageLoad(image) {
      image.isLoaded = true;
    },
    async onSubmit(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      try {
        // Upload new files to GCS
        let uploadedFiles = [];
        for (let file of this.FileUpload) {
          if (file.isNew && file.fileDataContext) {
            const formData = new FormData();
            formData.append("File", file.fileDataContext);
            formData.append("IsMaster", true);
            formData.append("FolderName", "MasterVendor");

            const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });

            if (uploadResponse.data && uploadResponse.data.fileInfoId) {
              uploadedFiles.push({
                fileInfoId: uploadResponse.data.fileInfoId,
                fileName: uploadResponse.data.fileInfoId,
                downloadUrl: uploadResponse.data.fileUrl,
              });
            }
          } else if (!file.isNew) {
            // Existing image - include in the list
            uploadedFiles.push({
              fileInfoId: file.fileInfoId,
              fileName: file.fileName,
              downloadUrl: file.downloadUrl,
            });
          }
        }

        // Prepare pictures data for API
        let picturesData = uploadedFiles.map((pic) => ({
          fileInfoId: pic.fileInfoId,
          fileName: pic.fileName,
          downloadUrl: pic.downloadUrl,
        }));

        const response = await axios.put("/Api/Vendors", {
          VendorId: this.$route.params.id,
          Latitude: this.suuLat,
          Longitude: this.suuLng,
          InActiveStatus: !this.suuInActiveStatus,
          VendorPictures: picturesData,
          OwnerTypeCode: this.OwnerTypeCode,
        });

        if (response.data.status) {
          KTApp.unblockPage();
          Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
            router.go(-1);
            self.$parent.reloadDataTable(false);
          });
        } else {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        }
      } catch (error) {
        var errorMsg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message;
        Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
      } finally {
        KTApp.unblockPage();
      }
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition((position) => {
        this.suuLat = position.coords.latitude;
        this.suuLng = position.coords.longitude;
        this.suuMarkers = [
          {
            position: { lat: this.suuLat, lng: this.suuLng },
            animation: google.maps.Animation.DROP,
          },
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.suuLat = location.latLng.lat();
      this.suuLng = location.latLng.lng();
      map: this.map;
      this.suuMarkers = [{ position: { lat: this.suuLat, lng: this.suuLng } }];
    },
    openMap() {
      var self = this;
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          self.suuLat +
          "," +
          self.suuLng,
        "_blank"
      );
    },
    LoadOwnerTypeCodeOption: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
          params: {
            page: 1,
            all: true,
            searchCode: "OWNER_SUP"
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OwnerTypeCodeOption.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();
    self.LoadOwnerTypeCodeOption();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    //set validation rules
    $(this.$refs.form).validate({
      rules: {
        //SteContactName: "required"
      },
      messages: {
        //SteContactName: "กรุณาระบุชื่อผู้ติดต่อ"
      },
    });

    axios
      .get("/Api/Vendors/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.suuNo = response.data.no;
          self.suuName = response.data.name;
          self.suuAddress = response.data.address;
          self.suuTaxNo = response.data.taxNo;
          self.suuEmail = response.data.email;
          self.suuTel = response.data.tel;
          self.suuInActiveStatus = !response.data.inActiveStatus;
          self.OwnerTypeCode = response.data.ownerTypeCode;

          //Set lat lng
          response.data.latitude === null
            ? (self.suuLat = null)
            : (self.suuLat = parseFloat(response.data.latitude));
          response.data.longitude === null
            ? (self.suuLng = null)
            : (self.suuLng = parseFloat(response.data.longitude));

          self.suuMarkers = [
            { position: { lat: self.suuLat, lng: self.suuLng } },
          ];

          // Load existing pictures into FileUpload array
          if (response.data.pictures && response.data.pictures.length > 0) {
            response.data.pictures.forEach((element) => {
              self.FileUpload.push({
                pictureId: element.pictureId,
                urlImg: element.urlImg,
                fileName: element.fileName,
                fileInfoId: element.fileInfoId,
                downloadUrl: element.downloadUrl,
                isNew: false,
                isLoaded: true,
              });
            });
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลคลังสินค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btn-reload-img-vendor {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btn-delete-img-vendor {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btn-remove-img-vendor {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/Supplier/SupplierUpdate.vue